export class EdlUserForm {
    CompletedDate: Date;
    CreatedDate: Date;
    FormAnswers: any;
    FormId: string;
    ModifiedDate: Date;
    ModifiedBy: string;
    Status: number;
    UserFormId: string;
    UserId: string;
    UserName: string;
    ItemTitle: string;
    IsHistory:boolean;
}